<template>
  <span>
    <el-button
      type="primary"
      size="mini"
      :disabled="!form.products.length || order.status !== 'A'"
      @click="visible = true"
    >
      Add Tracking ID
    </el-button>
    <el-dialog class="text-left" title="Add Tracking ID" :visible.sync="visible">
      <el-form :model="form" ref="form" @submit.prevent.native="onSubmit">
        <div class="row">
          <div class="col-12 col-md-6">
            <el-form-item label="Logistics Provider">
              <el-select v-model="form.logistics_provider" placeholder="Select logistics provider">
                <el-option label="None" :value="null"></el-option>
                <el-option v-for="provider in providers" :key="provider" :label="provider" :value="provider"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-12 col-md-6">
            <el-form-item label="Tracking ID">
              <el-input v-model="form.tracking_id"></el-input>
            </el-form-item>
          </div>
        </div>
        <h2 class="h4">Contents</h2>
        <div class="rounded border p-3 mb-4">
          <div v-for="product in form.products" :key="product.product_variant.id" class="row mb-4">
            <div class="col-6">
              <div class="d-flex">
                <div>
                  <img class="mr-2" width="50" height="50" align="left" :src="`https://ucarecdn.com/${ product.image_id }/-/scale_crop/300x300/center/-/quality/lightest/`" style="min-width: 50px;">
                </div>
                <div class="flex-grow-1">
                  <strong>{{ product.title }}</strong>
                  <div class="text-muted">{{ product.product_variant.barcode.type }} {{ product.product_variant.barcode.value }}</div>
                  <div class="text-muted">{{ product.sku }}</div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <el-input-number
                v-model="product.quantity"
                :min="1"
                :max="selectedProducts.find(item => item.product_variant.id === product.product_variant.id).quantity - selectedProducts.find(item => item.product_variant.id === product.product_variant.id).quantity_shipped"
              />
            </div>
          </div>
        </div>
        <el-button size="small" native-type="submit" type="primary" :loading="loading">Submit</el-button>
        <el-button size="small" @click="visible = false">Cancel</el-button>
      </el-form>
    </el-dialog>
  </span>
</template>

<script>
export default {
  props: {
    order: Object,
    selectedProducts: Array,
  },

  data() {
    return {
      visible: false,
      loading: false,
      form: {
        order_id: this.order.id,
        products: this.selectedProducts,
        logistics_provider: null,
        tracking_id: null,
      },
      providers: ['Ninja Logistics'],
    }
  },

  methods: {
    async onSubmit() {
      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          var { data } = await this.$http.post(`/shipments`, this.form)
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.$emit('success')
        this.$message.success(data.message)
        this.visible = false
      })
    },
  },

  watch: {
    selectedProducts(value) {
      this.form.products = JSON.parse(JSON.stringify(value))
    },
  },
}
</script>
